import { history } from 'duck/store'
import React from 'react'
import { TableColumn } from 'scenes/Dashboard/components-next/Table'
import { makeStyles } from 'tss-react/mui'

import SectionLoading from '../../../../components/SectionLoading'
import { ScoutingCampaignTableActions } from './components'
import { useScoutingCampaignListViewStore } from './ScoutingCampaignListViewStore'
import { ScoutingCampaignTable } from '../../components/ScoutingCampaignTable'
import { ScoutingCampaign } from '../../../../../../entities-next/scoutingCampaign'
import { getScoutingCampaignDetailsFormDataPath } from '../ScoutingCampaignDetailsView/ScoutingCampaignDetailsView.routes'

export type ScoutingCampaignListViewContentProps = {
  className?: string
}

export function ScoutingCampaignListViewContent({ className }: ScoutingCampaignListViewContentProps) {
  const {
    state: { status, data = [], currentPage, isPreviousData, limit },
    actions: { goToPage },
  } = useScoutingCampaignListViewStore()
  const { classes } = useStyles()
  const isLoading = status === 'loading' || isPreviousData

  return (
    <div className={className}>
      {isLoading && <SectionLoading className={classes.loading} />}
      <ScoutingCampaignTable
        data={data}
        currentPage={currentPage}
        limit={limit}
        onChangePage={goToPage}
        extraColumns={actionsRow}
        onRowSelect={onRowSelect}
      />
    </div>
  )
}

function onRowSelect(scoutingCampaign: ScoutingCampaign) {
  history.push(getScoutingCampaignDetailsFormDataPath(scoutingCampaign.id))
}

const actionsRow: TableColumn<ScoutingCampaign>[] = [
  {
    Header: 'Actions',
    accessor: getCorporateActionsColumn,
    preventEvents: true,
    width: 50,
  },
]

function getCorporateActionsColumn(scoutingCampaign: ScoutingCampaign) {
  return <ScoutingCampaignTableActions scoutingCampaign={scoutingCampaign} />
}

const useStyles = makeStyles()({
  content: {
    position: 'relative',
  },
  loading: {
    position: 'absolute',
    zIndex: 2,
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(255,255,255,0.5)',
  },
})
